"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.deleteUserRedeemRewardIsLoadingSelector = exports.deleteUserRedeemRewardErrorSelector = exports.deletedUserIdRedeemRewardSelector = exports.deleteUserRedeemRewardSelector = exports.userRewardsStateSelector = void 0;

var _reselect = require("reselect");

var userStateSelector = function userStateSelector(state) {
  return state.user;
};

var userRewardsStateSelector = (0, _reselect.createSelector)(userStateSelector, function (user) {
  return user.rewards;
});
exports.userRewardsStateSelector = userRewardsStateSelector;
var deleteUserRedeemRewardSelector = (0, _reselect.createSelector)(userRewardsStateSelector, function (rewards) {
  return rewards.deleteUserRedeemReward;
});
exports.deleteUserRedeemRewardSelector = deleteUserRedeemRewardSelector;
var deletedUserIdRedeemRewardSelector = (0, _reselect.createSelector)(deleteUserRedeemRewardSelector, function (deleteUserRedeemReward) {
  return deleteUserRedeemReward.userIdRedeemDeleted;
});
exports.deletedUserIdRedeemRewardSelector = deletedUserIdRedeemRewardSelector;
var deleteUserRedeemRewardErrorSelector = (0, _reselect.createSelector)(deleteUserRedeemRewardSelector, function (deleteUserRedeemReward) {
  return deleteUserRedeemReward.error;
});
exports.deleteUserRedeemRewardErrorSelector = deleteUserRedeemRewardErrorSelector;
var deleteUserRedeemRewardIsLoadingSelector = (0, _reselect.createSelector)(deleteUserRedeemRewardSelector, function (deleteUserRedeemReward) {
  return deleteUserRedeemReward.isLoading;
});
exports.deleteUserRedeemRewardIsLoadingSelector = deleteUserRedeemRewardIsLoadingSelector;
var _default = {
  deletedUserIdRedeemRewardSelector: deletedUserIdRedeemRewardSelector,
  deleteUserRedeemRewardErrorSelector: deleteUserRedeemRewardErrorSelector,
  deleteUserRedeemRewardIsLoadingSelector: deleteUserRedeemRewardIsLoadingSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map